import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type SponsorsData = {
  viewMode: string
  marginBottom: string
  topText?: string
}

export const sponsors: DynamicContentType<SponsorsData> = {
  name: 'sponsors',
  viewName: 'Sponsorer',
  icon: LucideIconName.Crown,
  uuid: '',
  featureKey: 'sponsors',
  data: {
    topText: 'Våra sponsorer',
    viewMode: 'grid',
    marginBottom: '1rem',
  },
}
